// extracted by mini-css-extract-plugin
module.exports = {"container":"FullHistoryModal_container__1-weP","header":"FullHistoryModal_header__26zIf","history":"FullHistoryModal_history__3Pvhc"};